const contrast0 = [
  [
    [0x80, 0x8f, 0xd0],
    [0x8b, 0xbf, 0xe0],
    [0x82, 0x9b, 0xd4],
    [0x8e, 0xcb, 0xe4],
  ],
  [
    [0x87, 0xaf, 0xdb],
    [0x83, 0x9f, 0xd5],
    [0x8a, 0xbb, 0xdf],
    [0x86, 0xab, 0xd9],
  ],
  [
    [0x81, 0x97, 0xd2],
    [0x8d, 0xc7, 0xe3],
    [0x80, 0x93, 0xd1],
    [0x8c, 0xc3, 0xe1],
  ],
  [
    [0x89, 0xb7, 0xdd],
    [0x85, 0xa7, 0xd8],
    [0x88, 0xb3, 0xdc],
    [0x84, 0xa3, 0xd6],
  ],
];
const contrast1 = [
  [
    [0x82, 0x90, 0xc8],
    [0x8c, 0xba, 0xdc],
    [0x84, 0x9a, 0xcd],
    [0x8f, 0xc4, 0xe1],
  ],
  [
    [0x89, 0xac, 0xd5],
    [0x85, 0x9e, 0xce],
    [0x8b, 0xb6, 0xda],
    [0x88, 0xa8, 0xd3],
  ],
  [
    [0x83, 0x97, 0xcb],
    [0x8e, 0xc1, 0xdf],
    [0x82, 0x93, 0xc9],
    [0x8d, 0xbd, 0xdd],
  ],
  [
    [0x8a, 0xb3, 0xd8],
    [0x87, 0xa5, 0xd2],
    [0x89, 0xaf, 0xd7],
    [0x86, 0xa1, 0xd0],
  ],
];
const contrast2 = [
  [
    [0x84, 0x90, 0xc0],
    [0x8d, 0xb4, 0xd8],
    [0x86, 0x99, 0xc6],
    [0x8f, 0xbd, 0xde],
  ],
  [
    [0x8a, 0xa8, 0xd0],
    [0x87, 0x9c, 0xc8],
    [0x8c, 0xb1, 0xd6],
    [0x89, 0xa5, 0xce],
  ],
  [
    [0x85, 0x96, 0xc4],
    [0x8e, 0xba, 0xdc],
    [0x84, 0x93, 0xc2],
    [0x8d, 0xb7, 0xda],
  ],
  [
    [0x8b, 0xae, 0xd4],
    [0x88, 0xa2, 0xcc],
    [0x8a, 0xab, 0xd2],
    [0x87, 0x9f, 0xca],
  ],
];
const contrast3 = [
  [
    [0x85, 0x91, 0xb8],
    [0x8e, 0xae, 0xd3],
    [0x87, 0x98, 0xbe],
    [0x90, 0xb5, 0xda],
  ],
  [
    [0x8b, 0xa4, 0xca],
    [0x88, 0x9a, 0xc1],
    [0x8d, 0xab, 0xd1],
    [0x8a, 0xa2, 0xc8],
  ],
  [
    [0x86, 0x95, 0xbc],
    [0x8f, 0xb3, 0xd8],
    [0x85, 0x93, 0xba],
    [0x8e, 0xb0, 0xd6],
  ],
  [
    [0x8c, 0xa9, 0xcf],
    [0x89, 0x9f, 0xc5],
    [0x8b, 0xa6, 0xcc],
    [0x88, 0x9d, 0xc3],
  ],
];
const contrast4 = [
  [
    [0x86, 0x91, 0xb1],
    [0x8e, 0xa9, 0xd0],
    [0x88, 0x97, 0xb8],
    [0x90, 0xaf, 0xd8],
  ],
  [
    [0x8b, 0xa1, 0xc6],
    [0x88, 0x99, 0xbb],
    [0x8d, 0xa7, 0xcd],
    [0x8a, 0x9f, 0xc3],
  ],
  [
    [0x87, 0x95, 0xb6],
    [0x8f, 0xad, 0xd5],
    [0x86, 0x93, 0xb3],
    [0x8e, 0xab, 0xd3],
  ],
  [
    [0x8c, 0xa5, 0xcb],
    [0x8a, 0x9d, 0xc0],
    [0x8c, 0xa3, 0xc8],
    [0x89, 0x9b, 0xbe],
  ],
];
const contrast5 = [
  [
    [0x87, 0x92, 0xaa],
    [0x8f, 0xa4, 0xcc],
    [0x89, 0x96, 0xb2],
    [0x91, 0xa8, 0xd5],
  ],
  [
    [0x8c, 0x9e, 0xc1],
    [0x89, 0x98, 0xb5],
    [0x8e, 0xa2, 0xc9],
    [0x8b, 0x9c, 0xbe],
  ],
  [
    [0x88, 0x95, 0xaf],
    [0x90, 0xa7, 0xd2],
    [0x87, 0x93, 0xac],
    [0x8f, 0xa5, 0xcf],
  ],
  [
    [0x8d, 0xa1, 0xc6],
    [0x8b, 0x9b, 0xbb],
    [0x8d, 0x9f, 0xc3],
    [0x8a, 0x99, 0xb8],
  ],
];
const contrast6 = [
  [
    [0x88, 0x92, 0xa5],
    [0x8f, 0xa0, 0xc9],
    [0x89, 0x95, 0xae],
    [0x91, 0xa3, 0xd2],
  ],
  [
    [0x8d, 0x9b, 0xbd],
    [0x8a, 0x96, 0xb1],
    [0x8e, 0x9f, 0xc6],
    [0x8c, 0x9a, 0xba],
  ],
  [
    [0x89, 0x94, 0xab],
    [0x90, 0xa2, 0xcf],
    [0x88, 0x93, 0xa8],
    [0x90, 0xa1, 0xcc],
  ],
  [
    [0x8e, 0x9d, 0xc3],
    [0x8b, 0x99, 0xb7],
    [0x8d, 0x9c, 0xc0],
    [0x8b, 0x97, 0xb4],
  ],
];

const contrast7 = [
  [
    [0x89, 0x92, 0xa2],
    [0x8f, 0x9e, 0xc6],
    [0x8a, 0x95, 0xab],
    [0x91, 0xa1, 0xcf],
  ],
  [
    [0x8d, 0x9a, 0xba],
    [0x8b, 0x96, 0xae],
    [0x8f, 0x9d, 0xc3],
    [0x8c, 0x99, 0xb7],
  ],
  [
    [0x8a, 0x94, 0xa8],
    [0x90, 0xa0, 0xcc],
    [0x89, 0x93, 0xa5],
    [0x90, 0x9f, 0xc9],
  ],
  [
    [0x8e, 0x9c, 0xc0],
    [0x8c, 0x98, 0xb4],
    [0x8e, 0x9b, 0xbd],
    [0x8b, 0x97, 0xb1],
  ],
];
const contrast8 = [
  [
    [0x8a, 0x92, 0xa1],
    [0x90, 0x9d, 0xbe],
    [0x8b, 0x94, 0xa8],
    [0x91, 0xa0, 0xc5],
  ],
  [
    [0x8e, 0x99, 0xb4],
    [0x8c, 0x95, 0xaa],
    [0x8f, 0x9c, 0xbb],
    [0x8d, 0x98, 0xb2],
  ],
  [
    [0x8b, 0x93, 0xa5],
    [0x91, 0x9f, 0xc3],
    [0x8a, 0x92, 0xa3],
    [0x90, 0x9e, 0xc0],
  ],
  [
    [0x8f, 0x9b, 0xb9],
    [0x8d, 0x97, 0xaf],
    [0x8e, 0x9a, 0xb6],
    [0x8c, 0x96, 0xad],
  ],
];
const contrast9 = [
  [
    [0x8b, 0x92, 0xa0],
    [0x90, 0x9c, 0xb6],
    [0x8c, 0x94, 0xa5],
    [0x91, 0x9f, 0xbc],
  ],
  [
    [0x8e, 0x99, 0xaf],
    [0x8c, 0x95, 0xa7],
    [0x8f, 0x9b, 0xb4],
    [0x8e, 0x98, 0xad],
  ],
  [
    [0x8b, 0x93, 0xa3],
    [0x91, 0x9e, 0xba],
    [0x8b, 0x92, 0xa1],
    [0x90, 0x9d, 0xb8],
  ],
  [
    [0x8f, 0x9a, 0xb2],
    [0x8d, 0x97, 0xab],
    [0x8e, 0x99, 0xb0],
    [0x8d, 0x96, 0xa9],
  ],
];
const contrast10 = [
  [
    [0x8c, 0x92, 0x9e],
    [0x90, 0x9b, 0xae],
    [0x8d, 0x94, 0xa2],
    [0x91, 0x9d, 0xb2],
  ],
  [
    [0x8f, 0x98, 0xa9],
    [0x8d, 0x95, 0xa3],
    [0x90, 0x9a, 0xad],
    [0x8e, 0x97, 0xa7],
  ],
  [
    [0x8c, 0x93, 0xa0],
    [0x91, 0x9c, 0xb1],
    [0x8c, 0x92, 0x9f],
    [0x90, 0x9b, 0xaf],
  ],
  [
    [0x8f, 0x99, 0xab],
    [0x8e, 0x96, 0xa6],
    [0x8f, 0x98, 0xaa],
    [0x8d, 0x95, 0xa4],
  ],
];
const contrast11 = [
  [
    [0x8d, 0x92, 0x9c],
    [0x90, 0x99, 0xa8],
    [0x8d, 0x93, 0x9f],
    [0x91, 0x9b, 0xab],
  ],
  [
    [0x8f, 0x97, 0xa4],
    [0x8e, 0x94, 0xa0],
    [0x90, 0x98, 0xa7],
    [0x8f, 0x96, 0xa3],
  ],
  [
    [0x8d, 0x93, 0x9e],
    [0x91, 0x9a, 0xaa],
    [0x8d, 0x92, 0x9d],
    [0x91, 0x9a, 0xa9],
  ],
  [
    [0x90, 0x98, 0xa6],
    [0x8e, 0x95, 0xa2],
    [0x8f, 0x97, 0xa5],
    [0x8e, 0x95, 0xa1],
  ],
];
const contrast12 = [
  [
    [0x8e, 0x92, 0x9b],
    [0x91, 0x98, 0xa2],
    [0x8e, 0x93, 0x9c],
    [0x91, 0x9a, 0xa4],
  ],
  [
    [0x90, 0x96, 0xa0],
    [0x8f, 0x94, 0x9d],
    [0x90, 0x98, 0xa1],
    [0x8f, 0x95, 0x9f],
  ],
  [
    [0x8e, 0x93, 0x9c],
    [0x91, 0x99, 0xa3],
    [0x8e, 0x92, 0x9b],
    [0x91, 0x99, 0xa3],
  ],
  [
    [0x90, 0x97, 0xa1],
    [0x8f, 0x95, 0x9e],
    [0x90, 0x97, 0xa0],
    [0x8f, 0x94, 0x9e],
  ],
];
const contrast13 = [
  [
    [0x8f, 0x92, 0x99],
    [0x91, 0x97, 0x9e],
    [0x8f, 0x93, 0x9a],
    [0x91, 0x98, 0x9f],
  ],
  [
    [0x90, 0x95, 0x9c],
    [0x8f, 0x93, 0x9a],
    [0x91, 0x96, 0x9d],
    [0x90, 0x95, 0x9c],
  ],
  [
    [0x8f, 0x92, 0x99],
    [0x91, 0x98, 0x9f],
    [0x8f, 0x92, 0x99],
    [0x91, 0x97, 0x9e],
  ],
  [
    [0x90, 0x96, 0x9d],
    [0x90, 0x94, 0x9b],
    [0x90, 0x95, 0x9c],
    [0x8f, 0x94, 0x9b],
  ],
];
const contrast14 = [
  [
    [0x90, 0x92, 0x97],
    [0x91, 0x95, 0x99],
    [0x90, 0x92, 0x97],
    [0x91, 0x96, 0x99],
  ],
  [
    [0x91, 0x94, 0x98],
    [0x90, 0x93, 0x97],
    [0x91, 0x95, 0x99],
    [0x90, 0x94, 0x98],
  ],
  [
    [0x90, 0x92, 0x97],
    [0x91, 0x96, 0x99],
    [0x90, 0x92, 0x97],
    [0x91, 0x96, 0x99],
  ],
  [
    [0x91, 0x95, 0x98],
    [0x90, 0x93, 0x98],
    [0x91, 0x94, 0x98],
    [0x90, 0x93, 0x97],
  ],
];
const contrast15 = [
  [
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
  ],
  [
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
  ],
  [
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
  ],
  [
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
    [0x92, 0x92, 0x92],
  ],
];

const highLightDitherMatricies = [
  contrast0,
  contrast1,
  contrast2,
  contrast3,
  contrast4,
  contrast5,
  contrast6,
  contrast7,
  contrast8,
  contrast9,
  contrast10,
  contrast11,
  contrast12,
  contrast13,
  contrast14,
  contrast15,
];

export { highLightDitherMatricies };
